import { render, staticRenderFns } from "./RentabilityHeader.vue?vue&type=template&id=73204ecf&scoped=true"
import script from "./RentabilityHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./RentabilityHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RentabilityHeader.vue?vue&type=style&index=0&id=73204ecf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73204ecf",
  null
  
)

export default component.exports